import http from './http';

export const burialPointApi = (params, config) => http.post('/cfmotoserverapp/dbpoint/send', params, { ...config });

export const getBaseInfoApi = (params, config) => http.get('/cfmotoservermine/baseInfo', { params, ...config });
export default {};
